import { render, staticRenderFns } from "./CreateCampaign.vue?vue&type=template&id=56b8bb05&scoped=true&"
import script from "./CreateCampaign.vue?vue&type=script&lang=js&"
export * from "./CreateCampaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b8bb05",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56b8bb05')) {
      api.createRecord('56b8bb05', component.options)
    } else {
      api.reload('56b8bb05', component.options)
    }
    module.hot.accept("./CreateCampaign.vue?vue&type=template&id=56b8bb05&scoped=true&", function () {
      api.rerender('56b8bb05', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Marketing/CreateCampaign.vue"
export default component.exports